export default __webpack_public_path__ + "5b98a120aeec3f5a1aeb9c0a8c011cf8.svg";